module.exports = __webpack_public_path__ + "img/vde.ffd2bb64.svg";